import React from 'react';
import ReactMarkdownWithHtml from 'react-markdown/with-html';


const HtmlMarkdown = props => {
    const {def} = props;
    return <ReactMarkdownWithHtml allowDangerousHtml data-input={'htmlmarkdown_de'}>{def.markdown}</ReactMarkdownWithHtml>
}

export default HtmlMarkdown;
